export class WebSocketEventName {
    public static CONNECTION_READY = "connection/ready";
    public static CONNECTION_ERROR = "connection/error";
    public static ALERT = "alert";
}